import dictionary from '../../../../utils/dictionary'

import { PERIPHERAL } from '@/api/apiModules'

export default {
  refreshInterval: false,
  viewType: 'table',
  module: PERIPHERAL,
  relationSearch: true,
  allowStatus: {},
  toolbar: {
    searchWidth: 360,
    searchPlaceholder: '请输入外设名称',
    moreBtnWidth: 160,
    searchFieldNameArr: ['name'],
    hasColAdjustment: true,
    items: [
      {
        slot: 'refresh-rigtht',
        label: '同步云智助手外设',
        props: {
          type: 'primary',
          icon: 'el-icon-plus'
        },
        action: 'syncYunZhiPeripheral'
      }
    ]
  },
  view: {
    'cell-class-name': 'sk-customize-cell-hight',
    columns: [
      {
        props: {
          label: 'pocMng.peripheral.name',
          prop: 'name',
          width: 285,
          sortField: 'name'
        },
        dataType: 'custom',
        custom: function(row, h, value, e) {
          return (
            <div
              class="sk-link--normal  wsp-width-100"
              on-click={$event => {
                this.$store.dispatch('ShowPeripheralDetail', row)
              }}
            >
              {value}
            </div>
          )
        }
      },
      {
        props: {
          label: 'pocMng.peripheral.type',
          prop: 'typeCN',
          width: 105,
          sortField: 'type'
        }
      },
      {
        props: {
          label: 'pocMng.peripheral.interfaceType',
          width: 115,
          prop: 'interfaceType',
          sortField: 'interfaceType'
        }
      },
      {
        props: {
          label: 'pocMng.peripheral.manufacturer',
          width: 135,
          prop: 'manufacturer',
          sortField: 'manufacturer'
        }
      },
      {
        props: {
          label: '硬件编码',
          width: 135,
          prop: 'hardwareCode',
          sortField: 'hardwareCode'
        }
      },
      {
        props: {
          label: '兼容信息',
          prop: 'id',
          sortField: 'id'
        },
        dataType: 'custom',
        custom: function(data, h) {
          var html = []

          if (data.compat && data.compat.length === 0) {
            return <div>无</div>
          }
          for (const version of data.compat) {
            html.push(
              <div style="padding:1px">
                <span>
                  <el-tag type={dictionary['compatibleStatus'][version.compatibleStatus]['type']}>
                    {dictionary['compatibleStatus'][version.compatibleStatus]['label']}
                  </el-tag>
                  <span v-show={version.scheme}>【{version.scheme}】</span>
                  <span>【{version.productVersion}】及以上</span>
                </span>
              </div>
            )
          }
          return html
        }
      },
      {
        props: {
          label: '创建时间',
          prop: 'createTime',
          width: 160,
          sortField: 'createTime'
        },
        dataType: 'date'
      },
      {
        props: {
          label: '更新时间',
          prop: 'updateTime',
          width: 160,
          sortField: 'updateTime'
        },
        dataType: 'date'
      },
      {
        //操作
        props: {
          showBtnNum: '2',
          fixed: null
        },
        dataType: 'operation'
      }
    ],
    menus: [
      {
        icon: 'el-icon-edit',
        label: '兼容性列表',
        command: 'CompatibleProductRelation',
        name: 'CompatibleProductRelation'
      },
      {
        icon: 'el-icon-edit',
        label: '关联用例',
        command: 'peripheralRelateTestCase',
        name: 'peripheralRelateTestCase'
      }
      // {
      //   icon: 'el-icon-edit',
      //   label: 'edit',
      //   command: 'PeripheralEdit',
      //   name: 'edit'
      // }
      // {
      //   icon: 'el-icon-delete',
      //   label: 'delete',
      //   command: 'PeripheralDelete',
      //   name: 'delete',
      //   confirm: {
      //     msg: 'tips.confirm.peripheralMng.deleteMsg'
      //   }
      // }
    ]
  }
}
